/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { BusinessObjectDefinitionSubjectMatterExpert } from '../model/businessObjectDefinitionSubjectMatterExpert';
import { BusinessObjectDefinitionSubjectMatterExpertCreateRequest } from '../model/businessObjectDefinitionSubjectMatterExpertCreateRequest';
import { BusinessObjectDefinitionSubjectMatterExpertKeys } from '../model/businessObjectDefinitionSubjectMatterExpertKeys';
import { ErrorInformation } from '../model/errorInformation';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class BusinessObjectDefinitionSubjectMatterExpertService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * createBusinessObjectDefinitionSubjectMatterExpert
     * Creates a new business object definition subject matter expert. &lt;p&gt;Requires WRITE or WRITE_DESCRIPTIVE_CONTENT permission on namespace&lt;/p&gt;
     * @param businessObjectDefinitionSubjectMatterExpertCreateRequest the information needed to create a business object definition subject matter expert
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectDefinitionSubjectMatterExpertCreateBusinessObjectDefinitionSubjectMatterExpert(businessObjectDefinitionSubjectMatterExpertCreateRequest: BusinessObjectDefinitionSubjectMatterExpertCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectDefinitionSubjectMatterExpert>;
    public businessObjectDefinitionSubjectMatterExpertCreateBusinessObjectDefinitionSubjectMatterExpert(businessObjectDefinitionSubjectMatterExpertCreateRequest: BusinessObjectDefinitionSubjectMatterExpertCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectDefinitionSubjectMatterExpert>>;
    public businessObjectDefinitionSubjectMatterExpertCreateBusinessObjectDefinitionSubjectMatterExpert(businessObjectDefinitionSubjectMatterExpertCreateRequest: BusinessObjectDefinitionSubjectMatterExpertCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectDefinitionSubjectMatterExpert>>;
    public businessObjectDefinitionSubjectMatterExpertCreateBusinessObjectDefinitionSubjectMatterExpert(businessObjectDefinitionSubjectMatterExpertCreateRequest: BusinessObjectDefinitionSubjectMatterExpertCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (businessObjectDefinitionSubjectMatterExpertCreateRequest === null || businessObjectDefinitionSubjectMatterExpertCreateRequest === undefined) {
            throw new Error('Required parameter businessObjectDefinitionSubjectMatterExpertCreateRequest was null or undefined when calling businessObjectDefinitionSubjectMatterExpertCreateBusinessObjectDefinitionSubjectMatterExpert.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<BusinessObjectDefinitionSubjectMatterExpert>(`${this.configuration.basePath}/businessObjectDefinitionSubjectMatterExperts`,
            businessObjectDefinitionSubjectMatterExpertCreateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteBusinessObjectDefinitionSubjectMatterExpert
     * Deletes an existing business object definition subject matter expert. &lt;p&gt;Requires WRITE or WRITE_DESCRIPTIVE_CONTENT permission on namespace&lt;/p&gt;
     * @param namespace the namespace of the business object definition
     * @param businessObjectDefinitionName the name of the business object definition
     * @param userId the user id of the subject matter expert
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectDefinitionSubjectMatterExpertDeleteBusinessObjectDefinitionSubjectMatterExpert(namespace: string, businessObjectDefinitionName: string, userId: string, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectDefinitionSubjectMatterExpert>;
    public businessObjectDefinitionSubjectMatterExpertDeleteBusinessObjectDefinitionSubjectMatterExpert(namespace: string, businessObjectDefinitionName: string, userId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectDefinitionSubjectMatterExpert>>;
    public businessObjectDefinitionSubjectMatterExpertDeleteBusinessObjectDefinitionSubjectMatterExpert(namespace: string, businessObjectDefinitionName: string, userId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectDefinitionSubjectMatterExpert>>;
    public businessObjectDefinitionSubjectMatterExpertDeleteBusinessObjectDefinitionSubjectMatterExpert(namespace: string, businessObjectDefinitionName: string, userId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectDefinitionSubjectMatterExpertDeleteBusinessObjectDefinitionSubjectMatterExpert.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling businessObjectDefinitionSubjectMatterExpertDeleteBusinessObjectDefinitionSubjectMatterExpert.');
        }
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling businessObjectDefinitionSubjectMatterExpertDeleteBusinessObjectDefinitionSubjectMatterExpert.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<BusinessObjectDefinitionSubjectMatterExpert>(`${this.configuration.basePath}/businessObjectDefinitionSubjectMatterExperts/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}/userIds/${encodeURIComponent(String(userId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteBusinessObjectDefinitionSubjectMatterExpertsByBusinessObjectDefinition
     * Delete all business object definition subject matter experts for the specified business object definition. &lt;p&gt;Requires WRITE or WRITE_DESCRIPTIVE_CONTENT permission on namespace&lt;/p&gt;
     * @param namespace the namespace of the business object definition
     * @param businessObjectDefinitionName the name of the business object definition
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectDefinitionSubjectMatterExpertDeleteBusinessObjectDefinitionSubjectMatterExpertsByBusinessObjectDefinition(namespace: string, businessObjectDefinitionName: string, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectDefinitionSubjectMatterExpertKeys>;
    public businessObjectDefinitionSubjectMatterExpertDeleteBusinessObjectDefinitionSubjectMatterExpertsByBusinessObjectDefinition(namespace: string, businessObjectDefinitionName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectDefinitionSubjectMatterExpertKeys>>;
    public businessObjectDefinitionSubjectMatterExpertDeleteBusinessObjectDefinitionSubjectMatterExpertsByBusinessObjectDefinition(namespace: string, businessObjectDefinitionName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectDefinitionSubjectMatterExpertKeys>>;
    public businessObjectDefinitionSubjectMatterExpertDeleteBusinessObjectDefinitionSubjectMatterExpertsByBusinessObjectDefinition(namespace: string, businessObjectDefinitionName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectDefinitionSubjectMatterExpertDeleteBusinessObjectDefinitionSubjectMatterExpertsByBusinessObjectDefinition.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling businessObjectDefinitionSubjectMatterExpertDeleteBusinessObjectDefinitionSubjectMatterExpertsByBusinessObjectDefinition.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<BusinessObjectDefinitionSubjectMatterExpertKeys>(`${this.configuration.basePath}/businessObjectDefinitionSubjectMatterExperts/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getBusinessObjectDefinitionSubjectMatterExpertsByBusinessObjectDefinition
     * Gets a list of keys for all existing business object definition subject matter experts for the specified business object definition.
     * @param namespace the namespace of the business object definition
     * @param businessObjectDefinitionName the name of the business object definition
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectDefinitionSubjectMatterExpertGetBusinessObjectDefinitionSubjectMatterExpertsByBusinessObjectDefinition(namespace: string, businessObjectDefinitionName: string, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectDefinitionSubjectMatterExpertKeys>;
    public businessObjectDefinitionSubjectMatterExpertGetBusinessObjectDefinitionSubjectMatterExpertsByBusinessObjectDefinition(namespace: string, businessObjectDefinitionName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectDefinitionSubjectMatterExpertKeys>>;
    public businessObjectDefinitionSubjectMatterExpertGetBusinessObjectDefinitionSubjectMatterExpertsByBusinessObjectDefinition(namespace: string, businessObjectDefinitionName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectDefinitionSubjectMatterExpertKeys>>;
    public businessObjectDefinitionSubjectMatterExpertGetBusinessObjectDefinitionSubjectMatterExpertsByBusinessObjectDefinition(namespace: string, businessObjectDefinitionName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectDefinitionSubjectMatterExpertGetBusinessObjectDefinitionSubjectMatterExpertsByBusinessObjectDefinition.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling businessObjectDefinitionSubjectMatterExpertGetBusinessObjectDefinitionSubjectMatterExpertsByBusinessObjectDefinition.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<BusinessObjectDefinitionSubjectMatterExpertKeys>(`${this.configuration.basePath}/businessObjectDefinitionSubjectMatterExperts/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
